<!-- Opción 1 -->
<!-- <ul class="nav flex-column">
  <button
    type="button"
    name=""
    class="btn btn-outline-light"
    (click)="buttonClick()"
  >
    {{ item.getName() }}
  </button>
  <span *ngIf="item.areShowingItems()">
    <li class="nav-item" *ngFor="let item of item.getItems()">
      <app-menu-item
        [item]="item"
        (click)="(buttonClick)"
        (onClick)="buttonClick($event)"
      ></app-menu-item>
    </li>
  </span>
</ul> -->
<!-- Opción 2 -->
<!-- <div class="col-md-2">
  <button
    type="button"
    name=""
    class="btn btn-outline-light"
    (click)="buttonClick()"
  >
    {{ item.getFriendlyName() }}
  </button>
</div>
<div *ngIf="item.areShowingItems()">
  <app-menu-item
    *ngFor="let item of item.getItems()"
    [item]="item"
    (click)="(buttonClick)"
    (onClick)="buttonClick($event)"
  ></app-menu-item>
</div> -->
<!--Opción 3-->
<!-- Child level -->
<div
  class="w-100"
>
  <div
    class="text-center w-100 text-center margin-bottom-02"
  >
    <span *ngFor="let item of items">
      <app-menu-item
        class="animated fadeInDown"
        *ngIf="item.areShowingItems()"
        [items]="item.getItems()"
        [level]="level + 1"
      ></app-menu-item>
      <!-- (onClick)="childClick($event)" -->
    </span>
  </div>
  <!-- Actual level -->
  <div
    class="text-center w-100 overflow-x padding-05"
    [ngStyle]="{ backgroundColor: color }"
  >
    <span *ngFor="let item of items" class="mr1 ml-1">
      <app-button
        (onClick)="clickOnMe(item)"
        [item]="item.getButton()"
      ></app-button>
    </span>
  </div>
</div>
